(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-logo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const logo = document.querySelector('.homepage-hero-logo');
    if (!logo) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    const sections = Array.from(document.querySelectorAll('.shopify-section')).filter(
      (s) =>
        !s.classList.contains('shopify-section-group-header-group') &&
        !s.classList.contains('shopify-section-group-footer-group')
    );
    if (!sections.length) return;

    const stopSection = sections[sections.length - 1];
    let ticking = false;

    // Mobile fade distance (tweakable)
    const FADE_DISTANCE = 120; // px before last section midpoint

    const update = () => {
      ticking = false;

      const logoRect = logo.getBoundingClientRect();
      const desiredY = window.innerHeight / 2 - logoRect.height / 2;

      const sectionRect = stopSection.getBoundingClientRect();
      const sectionMidViewport = sectionRect.top + sectionRect.height / 2;

      // Always follow viewport center
      logo.style.transform = `translateX(-50%) translateY(${Math.round(desiredY)}px)`;

      // MOBILE: fade out instead of stopping
      if (isMobile) {
        const fadeStart = sectionMidViewport - FADE_DISTANCE;

        if (desiredY >= fadeStart) {
          const progress = Math.min(1, (desiredY - fadeStart) / FADE_DISTANCE);
          logo.style.opacity = `${1 - progress}`;
        } else {
          logo.style.opacity = '1';
        }
      }

      // DESKTOP: stopping behavior
      if (!isMobile) {
        const y = Math.round(Math.min(desiredY, sectionMidViewport));
        logo.style.transform = `translateX(-50%) translateY(${y}px)`;
      }

      logo.classList.add('is-ready');
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-scroll-footer-section"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.marquee__track');
      this.items = Array.from(this.track.children);

      if (!this.items.length) return;

      this.speed = 50; // px per second
      this.direction = getComputedStyle(this).getPropertyValue('--marquee-direction').trim() === 'reverse' ? 1 : -1;

      this.cloneUntilFilled();
      this.startAnimation();
    }

    cloneUntilFilled() {
      const trackWidth = () => this.track.scrollWidth;
      const containerWidth = this.offsetWidth;

      while (trackWidth() < containerWidth * 2) {
        this.items.forEach((item) => {
          this.track.appendChild(item.cloneNode(true));
        });
      }
    }

    startAnimation() {
      let start = null;
      const initialOffset = 0;
      const totalWidth = this.track.scrollWidth / 2;

      const animate = (timestamp) => {
        if (!start) start = timestamp;
        const elapsed = timestamp - start;
        const distance = (elapsed / 1000) * this.speed * this.direction;

        let translate = (initialOffset + distance) % totalWidth;
        this.track.style.transform = `translateX(${translate}px)`;

        requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    }
  }

  customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();
})();
